import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { SdvorSharedCmsComponents } from '../cms-components.enum';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        TitleModule: {
          module: () => import('./title-lazy.module').then((m) => m.TitleLazyModule),
          cmsComponents: [SdvorSharedCmsComponents.SdCMSTitleComponent],
        },
      },
    }),
  ],
})
export class TitleModule {}
